import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IDropdownProjects } from '../../../../interfaces/projects/IProjects'
import { useStore } from '../../../../Provider'
import { OPSkillsCombobox } from '../../../OPcomponents/OPSkillsCombobox'
import { initValues } from './AddNewPrivateProject'

const AddNewEmployer = (props: { deleteProjectConfirmation: boolean; isEdit: boolean }): JSX.Element => {
  const { deleteProjectConfirmation } = props
  const { t } = useTranslation()
  const rootStore = useStore()
  const { dropdownEmployers, allOtherEmployerDetails } = rootStore.projectStore
  const { validatedUser } = rootStore.loginStore

  const { values, handleChange, setFieldValue, errors, touched, setTouched } = useFormikContext<initValues>()

  const handleAdd = (val: string | IDropdownProjects) => {
    if (typeof val !== 'string' && val.key) {
      const curEmployer = allOtherEmployerDetails.find((emp) => emp.employerId === val.key)
      setFieldValue('employer', {
        name: curEmployer?.name,
        employerId: curEmployer?.employerId,
        userId: validatedUser,
        jobTitle: curEmployer?.jobTitle,
        startDate: curEmployer?.startDate,
        endDate: curEmployer?.endDate,
        jobDescriptionFi: curEmployer?.jobDescriptionFi,
        jobDescriptionEng: curEmployer?.jobDescriptionEng,
      })
      setFieldValue('project.employerId', curEmployer?.employerId)
    } else if (typeof val === 'string') {
      setFieldValue('employer', {
        name: val,
        employerId: -1,
        jobTitle: '',
        userId: validatedUser,
        startDate: null,
        endDate: null,
        jobDescriptionFi: '',
        jobDescriptionEng: '',
      })
    }
  }

  return (
    <Grid container gap={4}>
      <Grid item md={6} sm={12}>
        <OPSkillsCombobox
          freeSolo
          disabled={deleteProjectConfirmation}
          optionList={dropdownEmployers}
          name='employer.employerId'
          label={`${t('Projects.Employer')} *`}
          onChange={(e, val: string | IDropdownProjects) => {
            setTouched({ ...touched, employer: { ...touched.employer, employerId: true } })
            props.isEdit ? '' : handleChange(e)
            if (val) {
              handleAdd(val)
            }
          }}
          curState={dropdownEmployers.find((emp) => emp.key === values.employer.employerId)}
          manInput={props.isEdit ? false : true}
          multiple={false}
          bold
          error={touched.employer?.employerId && Boolean(errors.employer?.employerId)}
          helperText={t(errors.employer?.employerId || '')}
        />
      </Grid>
    </Grid>
  )
}

export default observer(AddNewEmployer)
